import { render, staticRenderFns } from "./postdoctor.vue?vue&type=template&id=e6cc94f4&scoped=true&"
import script from "./postdoctor.vue?vue&type=script&lang=js&"
export * from "./postdoctor.vue?vue&type=script&lang=js&"
import style0 from "./postdoctor.vue?vue&type=style&index=0&id=e6cc94f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cc94f4",
  null
  
)

export default component.exports